export const globalPartnerParametersInitialState = {
  partnerId: null,
  partnerName: null,
  country: null
};
